"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeBankTransferFailureReasonResponse = exports.EmployeeBankTransferStatusResponse = exports.EmployeeBankTransferTypeResponse = exports.EmployeeBankTransferIncludeable = void 0;
var EmployeeBankTransferIncludeable;
(function (EmployeeBankTransferIncludeable) {
    EmployeeBankTransferIncludeable["EXPENSE"] = "expense";
})(EmployeeBankTransferIncludeable = exports.EmployeeBankTransferIncludeable || (exports.EmployeeBankTransferIncludeable = {}));
var EmployeeBankTransferTypeResponse;
(function (EmployeeBankTransferTypeResponse) {
    EmployeeBankTransferTypeResponse["PRIMARY"] = "PRIMARY";
    EmployeeBankTransferTypeResponse["REFUND"] = "REFUND";
})(EmployeeBankTransferTypeResponse = exports.EmployeeBankTransferTypeResponse || (exports.EmployeeBankTransferTypeResponse = {}));
var EmployeeBankTransferStatusResponse;
(function (EmployeeBankTransferStatusResponse) {
    EmployeeBankTransferStatusResponse["PENDING"] = "PENDING";
    EmployeeBankTransferStatusResponse["SETTLED"] = "SETTLED";
    EmployeeBankTransferStatusResponse["FAILED"] = "FAILED";
    EmployeeBankTransferStatusResponse["REFUNDED"] = "REFUNDED";
})(EmployeeBankTransferStatusResponse = exports.EmployeeBankTransferStatusResponse || (exports.EmployeeBankTransferStatusResponse = {}));
var EmployeeBankTransferFailureReasonResponse;
(function (EmployeeBankTransferFailureReasonResponse) {
    EmployeeBankTransferFailureReasonResponse["FAILED_INTERNAL_VALIDATION"] = "FAILED_INTERNAL_VALIDATION";
    EmployeeBankTransferFailureReasonResponse["INCORRECT_BANK_DETAILS"] = "INCORRECT_BANK_DETAILS";
    EmployeeBankTransferFailureReasonResponse["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    EmployeeBankTransferFailureReasonResponse["POCKET_EXPENSE_CREATION_ERROR"] = "POCKET_EXPENSE_CREATION_ERROR";
    EmployeeBankTransferFailureReasonResponse["POCKET_INSUFFICIENT_FUNDS"] = "POCKET_INSUFFICIENT_FUNDS";
    EmployeeBankTransferFailureReasonResponse["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    EmployeeBankTransferFailureReasonResponse["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    EmployeeBankTransferFailureReasonResponse["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    EmployeeBankTransferFailureReasonResponse["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    EmployeeBankTransferFailureReasonResponse["UNKNOWN"] = "UNKNOWN";
})(EmployeeBankTransferFailureReasonResponse = exports.EmployeeBankTransferFailureReasonResponse || (exports.EmployeeBankTransferFailureReasonResponse = {}));
//# sourceMappingURL=employee-bank-transfer.js.map